// This file is auto-generated by ./bin/rails stimulus:manifest:update
// Run that command whenever you add a new controller or create them with
// ./bin/rails generate stimulus controllerName

import { application } from "./application";

import DateFieldsController from "./date_fields_controller";
application.register("date-fields", DateFieldsController);

import DismissibleBannerController from "./dismissible_banner_controller";
application.register("dismissible-banner", DismissibleBannerController);

import LanguageSelectorController from "./language_selector_controller";
application.register("language-selector", LanguageSelectorController);

import MinimumAgeController from "./minimum_age_controller";
application.register("minimum-age", MinimumAgeController);

import ModalController from "./modal_controller";
application.register("modal", ModalController);

import SearchController from "./search_controller";
application.register("search", SearchController);

import SigninFormController from "./signin_form_controller";
application.register("signin-form", SigninFormController);

import Students__ParentalConsentContactToggleController from "./students/parental_consent_contact_toggle_controller";
application.register(
  "students--parental-consent-contact-toggle",
  Students__ParentalConsentContactToggleController
);
